/* eslint-disable max-len */
import React from "react";
import { useSelector, connect } from "react-redux";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import get from "lodash/get";

import {
  AsyncSelectAutoComplete,
  Input,
  SelectAutocomplete,
  AutoSaveField as Field
} from "../../../../components/Form";
import { MAX_PO_BOX_LENGTH } from "./constants";
import { getCities, getSignatories } from "../../../../store/selectors/appConfig";
import { getObjectUsingDatalistValue } from "../../../../utils/helper";
import { Card } from "../../../../components/v2/Card/Card";

const SignatoryResidenceAddressComponent = ({
  index,
  isShareholderACompany,
  isFieldsRequired = true,
  getDatalistSearch,
  values
}) => {
  const basePath = `prospect.signatoryInfo[${index}].kycDetails.addressInfo[0].addressDetails`;
  const dataList = useSelector(getCities);

  let citySelected = {};
  if (dataList) {
    citySelected = getObjectUsingDatalistValue(dataList, values.residenceEmirate);
  }

  return (
    <Card title="Residence address">
      <Grid container spacing={3}>
        <Grid item sm={12} xs={12}>
          <Field
            name="residenceEmirate"
            path={`${basePath}.emirateCity`}
            placeholder="Start typing here ..."
            label="Emirate/City"
            // component={SelectAutocomplete}
            // datalistTo="city"
            component={AsyncSelectAutoComplete}
            getDatalistSearch={getDatalistSearch}
            codeType="LCTY"
            defaultValue={citySelected}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item sm={6} xs={12}>
          <Field
            name="residencePoBox"
            path={`${basePath}.poBox`}
            label="PO Box Number"
            placeholder="AB1234"
            component={Input}
            InputProps={{
              inputProps: { maxLength: MAX_PO_BOX_LENGTH, tabIndex: 0 }
            }}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Field
            name="residenceCountry"
            path={`${basePath}.country`}
            label="Country of residence"
            // value="United Arab Emirates"
            component={SelectAutocomplete}
            datalistId="country"
            disabled
            shrink
            tabIndex="0"
          />
        </Grid>
      </Grid>
    </Card>
  );
};

// PropTypes validation
SignatoryResidenceAddressComponent.propTypes = {
  /** Index of the signatory in the array */
  index: PropTypes.number.isRequired,
  /** Flag indicating if the shareholder is a company */
  isShareholderACompany: PropTypes.bool,
  /** Flag indicating if fields are required */
  isFieldsRequired: PropTypes.bool,
  /** Function to retrieve datalist search results */
  getDatalistSearch: PropTypes.func.isRequired,
  /** Form values object */
  values: PropTypes.shape({
    /** Emirate city value */
    residenceEmirate: PropTypes.string,
    /** PO Box number */
    residencePoBox: PropTypes.string,
    /** Country of residence */
    residenceCountry: PropTypes.string
  }).isRequired,
  /** Signatory residence address data from redux state */
  signatoryResAddress: PropTypes.shape({
    addressDetails: PropTypes.shape({
      emirateCity: PropTypes.string,
      poBox: PropTypes.string,
      country: PropTypes.string
    })
  })
};

const mapStateToProps = (state, { index }) => ({
  signatoryResAddress: get(getSignatories(state)[index], "kycDetails.addressInfo[0]", [])
});

export const SignatoryResidenceAddress = connect(mapStateToProps)(
  SignatoryResidenceAddressComponent
);
